import { render, staticRenderFns } from "./UpdateCredit.vue?vue&type=template&id=42635868&scoped=true&"
import script from "./UpdateCredit.vue?vue&type=script&lang=js&"
export * from "./UpdateCredit.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCredit.vue?vue&type=style&index=0&id=42635868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42635868",
  null
  
)

export default component.exports